/*
Documentation

this file renders all location_courts within the system

*/

import NotificationDelete from 'components/functional/notifications/Delete';
import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import moment from 'moment';
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Container, CardTitle } from "reactstrap";

const { SearchBar } = Search;

class CourtsAll extends React.Component {

    state = {}

    columns = [
        {
            dataField: "name",
            text: "Name",
            formatter: (cell, row) => (
                <Link to={`/core/locations/courts/view/${row._id}`}>
                    {row.name}
                </Link>
            )
        },
        {
            dataField: "email",
            text: "Email",
        },
        {
            dataField: "phone",
            text: "Phone",
        },
        {
            dataField: "_id",
            text: "Created At",

            formatter: (cell, row) => moment.unix(row.created_at).format("M/D/YYYY") + ' at ' + moment.unix(row.created_at).format("h:mm A")
        },
        {
            dataField: "x",
            text: "Actions",
            headerStyle: {textAlign: 'right'},
            formatter: (cell, row) => {
                return (
                    <div className="text-right">
                        <Link to={`/core/locations/courts/view/${row._id}`}><i className="fas fa-edit text-success mr-2"></i></Link>
                        <i onClick={() => this.setState({locationCourtToDelete: row})} className="fas fa-trash text-danger"></i>
                    </div>
                )
            }
        },
    ]

    pagination = paginationFactory({
        page: 1,
        alwaysShowAllBtns: true,
        showTotal: true,
        withFirstAndLast: false,
        sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
            <div className="dataTables_length" id="datatable-basic_length">
                <label>
                    Show{" "}
                    {
                    <select
                        name="datatable-basic_length"
                        aria-controls="datatable-basic"
                        className="form-control form-control-sm"
                        onChange={e => onSizePerPageChange(e.target.value)}
                    >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    }{" "}
                    entries.
                </label>
            </div>
        )
    });

    render() {

        const location_courts = this.props.location_courts;
        const locationCourtLength = this.props.location_courts.location_courts.length;
        const locationCourtToDelete = this.state.locationCourtToDelete;

        return (
            <>

            {locationCourtToDelete && (
                <NotificationDelete
                    deletionURL={`/api/v1/core/location_courts/delete/${locationCourtToDelete._id}`}
                    confirmBtnText="Delete Court"
                    title={`Delete ${locationCourtToDelete.name}`}
                    text="Deleting this court will not affect cases already assigned to it. You will, however, no longer be able to assign new cases to this court."
                    onClose={() => this.setState({locationCourtToDelete: null})}
                    onSuccess={() => {} }
                />
            )}

            <Container fluid>

                <Helmet>
                    <title>{`Courts (${locationCourtLength}) `}</title>
                    <meta name="description" content="Courts" />
                </Helmet>

                <DashHeaderOpen
                    title={<span><i className="fas fa-database mr-2 text-success " /> System</span>}
                    breadcrumb_1="Courts"
                    breadcrumb_2="All"
                    actionComponent={(
                        <Link  to="/core/locations/courts/create" className="btn btn-success"><i className="fas fa-plus mr-2 " />Add New</Link>
                    )}
                />

                <Card className="card-color card-primary">

                    <CardHeader>
                        <CardTitle className="mb-0">All Courts</CardTitle>
                    </CardHeader>

                    {location_courts.total ? (

                        <ToolkitProvider
                            data={location_courts.location_courts}
                            keyField="_id"
                            columns={this.columns}
                            search
                        >
                            {props => (
                                <>
                                    <div className="dataTables_filter px-4 pb pt-3 pb-2" >
                                        <label>
                                            Search:
                                            <SearchBar
                                                className="form-control-sm"
                                                placeholder="Name, Email, Phone"
                                                {...props.searchProps}
                                            />
                                        </label>
                                    </div>

                                    <div className=" table-responsive table-vertical-align">
                                        <BootstrapTable
                                            pagination={this.pagination}
                                            {...props.baseProps}
                                            bootstrap4={true}
                                            bordered={false}
                                        />
                                    </div>
                                </>
                            )}
                        </ToolkitProvider>

                    ) : (

                        <CardBody>

                            No courts have been created yet.

                            <Link to="/core/locations/courts/create">
                                <b className="text-warning"> Click here to create one.</b>
                            </Link>

                        </CardBody>

                    )}
                </Card>

            </Container>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        location_courts: state.location_courts
    };
};

export default connect(mapStateToProps, '')(CourtsAll);

